import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { EMethodsTypes } from '../types/enums';

const createMethodTypeStore = (
  persistName: string,
  defaultMethod: EMethodsTypes,
) =>
  create<{
    method: EMethodsTypes;
    setMethod: (method: EMethodsTypes) => void;
  }>()(
    persist(
      (set) => ({
        method: defaultMethod,
        setMethod: (method: EMethodsTypes) => {
          set({ method });
        },
      }),
      {
        name: persistName,
        partialize: (state) => ({
          ...state,
          method: state.method,
        }),
      },
    ),
  );

export const useMessengersMethodTypeStore = createMethodTypeStore(
  'messenger-method-type',
  EMethodsTypes.Whatsapp,
);

export const useAllMethodTypeStore = createMethodTypeStore(
  'all-method-type',
  EMethodsTypes.Email,
);
